var maxwindous = {
	data() {
		return {
			istrue: false,
			fullscreen: false,
		}
	},
	created() {
		const that = this
		window.onresize = function() {
			if (!that.checkFull()) {
				// 退出全屏后要执行的动作
				console.log('退出全屏')
				that.fullscreen = false
				that.istrue = false
			}
		}
	},
	methods: {
		checkFull() {
			//判断浏览器是否处于全屏状态 （需要考虑兼容问题）
			//火狐浏览器
			var isFull =
				document.mozFullScreen ||
				document.fullScreen ||
				//谷歌浏览器及Webkit内核浏览器
				document.webkitIsFullScreen ||
				document.webkitRequestFullScreen ||
				document.mozRequestFullScreen ||
				document.msFullscreenEnabled
			if (isFull === undefined) {
				isFull = false
			}
			return isFull
		},

		handleFullScreen(id) {
			this.istrue = true
			const element = document.getElementById(id)
			if (this.fullscreen) {
				if (document.exitFullscreen) {
					document.exitFullscreen()
				} else if (document.webkitCancelFullScreen) {
					document.webkitCancelFullScreen()
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen()
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen()
				}
			} else {
				if (element.requestFullscreen) {
					element.requestFullscreen()
				} else if (element.webkitRequestFullScreen) {
					element.webkitRequestFullScreen()
				} else if (element.mozRequestFullScreen) {
					element.mozRequestFullScreen()
				} else if (element.msRequestFullscreen) {
					// IE11
					element.msRequestFullscreen()
				}
			}
		},
	},
}

export default maxwindous
